import type { IconData } from '@stacksjs/iconify-core'

export const ga4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#ffe700\" d=\"M640 480H0V0h640z\"/><path fill=\"#36a100\" d=\"M640 160H0V0h640z\"/><path fill=\"#006dbc\" d=\"M640 480H0V320h640z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ga4x3
